export default [
    { //用户统计
        path: '/dataStatistics/user',
        name:'dataStatisticsUser',
        meta: { title: '用户统计'},
        component: () => import('../../views/dataStatistics/user.vue')
    },
    { //债权融资统计
        path: '/dataStatistics/debt',
        name:'dataStatisticsDebt',
        meta: { title: '债权融资统计'},
        component: () => import('../../views/dataStatistics/debt.vue')
    },
    { //融资租赁统计
        path: '/dataStatistics/financial',
        name:'dataStatisticsFinancial',
        meta: { title: '融资租赁统计'},
        component: () => import('../../views/dataStatistics/financial.vue')
    },
    { //股权融资统计
        path: '/dataStatistics/equity',
        name:'dataStatisticsEquity',
        meta: { title: '股权融资统计'},
        component: () => import('../../views/dataStatistics/equity.vue')
    },
    { //担保服务统计
        path: '/dataStatistics/guarantee',
        name:'dataStatisticsGuarantee',
        meta: { title: '担保服务统计'},
        component: () => import('../../views/dataStatistics/guarantee.vue')
    },
    { //政策指引统计
        path: '/dataStatistics/policy',
        name:'dataStatisticsPolicy',
        meta: { title: '政策指引统计'},
        component: () => import('../../views/dataStatistics/policy.vue')
    },
    { //孵化器统计
        path: '/dataStatistics/incubator',
        name:'dataStatisticsIncubator',
        meta: { title: '孵化器统计'},
        component: () => import('../../views/dataStatistics/incubator.vue')
    },
    { //资讯统计
        path: '/dataStatistics/message',
        name:'dataStatisticsMessage',
        meta: { title: '资讯统计'},
        component: () => import('../../views/dataStatistics/message.vue')
    },
    { //活动沙龙统计
        path: '/dataStatistics/salon',
        name:'dataStatisticsSalon',
        meta: { title: '活动沙龙统计'},
        component: () => import('../../views/dataStatistics/salon.vue')
    },
    { //中介服务统计
        path: '/dataStatistics/agent',
        name:'dataStatisticsAgent',
        meta: { title: '中介服务统计'},
        component: () => import('../../views/dataStatistics/agent.vue')
    },
    { //债权需求统计
        path: '/dataStatistics/demand',
        name:'dataStatisticsDemand',
        meta: { title: '债权需求统计'},
        component: () => import('../../views/dataStatistics/demand.vue')
    },
    { //访问人数统计
      path: '/dataStatistics/visitors',
      name:'dataStatisticsVisitors',
      meta: { title: '访问人数统计'},
      component: () => import('../../views/dataStatistics/visitors.vue')
  },
]